export default __webpack_public_path__ + "9247fe9.png";